import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { FC } from 'react';
import {
	IWizardChecklistItem,
	IWizardChecklistSection,
	IWizardProps
} from 'types/wizard';
import { getWizardDefaultSection } from '../utils/consts';
import WizardChecklistItem from './WizardChecklistItem';

interface IWizardCheckListSectionProps {
	name: string;
	onItemChanged: (item: IWizardChecklistSection) => void;
}

const WizardCheckListSection: FC<
	IWizardProps & IWizardCheckListSectionProps
> = ({ name, onItemChanged, ...props }) => {
	const {
		state: { checklist, archType }
	} = props;

	const section =
		(checklist && checklist[name]) || getWizardDefaultSection(name, archType);

	const handleClick = React.useCallback(
		(newItem: IWizardChecklistItem) => {
			const newItems = section.items.map((item) => {
				if (item.name === newItem.name) {
					return newItem;
				}
				return item;
			});
			onItemChanged({
				name,
				items: newItems
			});
		},
		[name, onItemChanged, section.items]
	);

	return (
		<>
			<Box flexDirection="row" display="flex">
				<Typography variant="body1" fontWeight="bold">
					{intl.tr(`wizard.phase.customize.sections.${name}`)}
				</Typography>
			</Box>
			{section.items.map((item) => (
				<Box
					key={item.name}
					py={{
						xs: 1,
						sm: 0
					}}
				>
					<WizardChecklistItem {...item} onClick={handleClick} />
				</Box>
			))}
		</>
	);
};

export default WizardCheckListSection;
